export { default } from './Toast';
export enum ToastType {
  error_network = 'error_network',
  failure = 'failure',
  success = 'success',
  warn = 'warn',
  first_level = 'first-level',
  second_level = 'second-level',
}
